<template>
  <base-currency-offer
    v-if="data && data.currencySettings"
    :currency-settings="data.currencySettings"
    currency-field-type="component_view"
    class="accounts-filters-popup__wrapper">
    <template #default="{ filtersList }">
      <accounts-mobile-field
        v-if="priceRangeEnabled"
        ref="fields"
        :field-instance="priceRangeInstance"
        @toggle-collapse="handleToggleCollapse(filtersList.length, ...arguments)"
        @input="handlePriceRange" />

      <accounts-mobile-field
        v-for="(field, index) in filtersList"
        :key="field.fieldData && field.fieldData.id ? field.fieldData.id : field.field._key"
        ref="fields"
        :is-disabled="field.fieldData._disabled"
        :field-instance="field"
        @toggle-collapse="handleToggleCollapse(index, ...arguments)"
        @input="handleFilterInput" />

      <div class="accounts-filters-popup__buttons">
        <button
          class="button button-main accounts-filters-popup__button"
          @click="showResults">
          Show results
        </button>

        <button
          class="button button-basic-dark accounts-filters-popup__button"
          @click="clearFilters">
          Clear all
        </button>
      </div>
    </template>
  </base-currency-offer>
</template>

<script>
import BaseCurrencyOffer from 'Components/Currency/BaseCurrencyOffer.vue';
import AccountsMobileField from 'Components/Accounts/Mobile/AccountsMobileField.vue';

export default {
  name: 'AccountsFiltersPopup',
  components: { AccountsMobileField, BaseCurrencyOffer },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      filterEntries: [],
      priceRange: null,
      priceRangeInstance: {
        field: {
          value: [],
          emit: 'input',
          component: 'dropdown-range',
          props: {
            placeholder: 'Price',
            range: {
              values: this.$route.query?.price_range?.split(',')?.map((el) => Number(el)) ?? [0, 2500],
              borderValues: [0, 2500],
              step: 1,
              zones: [
                {
                  from: 0,
                  to: 2500,
                  size: 100,
                  step: 1,
                },
              ],
              scaleStepsCount: 1,
            },
          },
        },
        fieldData: {
          isPriceRange: true,
          is_hidden: false,
          placeholder: 'Price',
        },
        setValue(event) {
          this.field.value = event;
        },
      },
      openedFilterId: null,
    };
  },

  computed: {
    priceRangeEnabled() {
      return this.data?.currencySettings?.is_price_range_enabled ?? false;
    },
  },

  methods: {
    showResults() {
      const result = {
        entries: this.filterEntries,
      };

      if (this.priceRangeEnabled) {
        result.priceRange = this.priceRange;
      }

      this.$vuedals.close(result);
    },

    clearFilters() {
      this.$vuedals.close({
        entries: [],
        shouldClear: true,
      });
    },

    handleFilterInput(entry) {
      this.filterEntries = this.filterEntries.filter((filterEntry) => filterEntry.field !== entry.field);
      this.filterEntries.push(entry);
    },

    handlePriceRange(entry) {
      this.priceRange = entry.value;
    },

    handleToggleCollapse(fieldIndex, state, collapseIndex) {
      if (!state) {
        return;
      }

      this.$refs.fields.forEach((field, index) => {
        if (fieldIndex === index) {
          if (collapseIndex === 0) {
            field.$refs?.collapseRange?.toggleCollapse(false);
          } else {
            field.$refs.collapse.toggleCollapse(false);
          }
        } else {
          field.$refs?.collapseRange?.toggleCollapse(false);
          field.$refs.collapse.toggleCollapse(false);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.accounts-filters-popup,
.accounts-filters-popup .vuedal.mobile-panel-popup {
  max-height: unset !important;
  height: 100vh !important;
}

.accounts-filters-popup .vuedal.mobile-panel-popup {
  overflow-y: auto;
  height: 100vh !important;
}

@supports(height: 100dvh) {
  .accounts-filters-popup,
  .accounts-filters-popup .vuedal.mobile-panel-popup {
    height: 100dvh !important;
  }
}

.accounts-filters-popup .mobile-panel-popup__body {
  height: 100%;
  padding: 0 24px 0 !important;
}

.accounts-filters-popup .mobile-panel-popup__content {
  height: 100%;
}
</style>

<style scoped lang="scss">
.accounts-filters-popup__wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.accounts-filters-popup__buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: auto;
  padding: 32px 0;
}

.accounts-filters-popup__button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  font-size: 13px;
  font-weight: 500;
}
</style>
